// @core/api/endpoints/project/delete_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete epic
 * Deletes an epic from the project. Items linked to the epic are unlinked but remain in the project.
 */
export async function DeleteEpic(
  project_id: string,
  epic_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics/:epic_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':epic_id', encodeURIComponent(epic_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
